import { render, staticRenderFns } from "./new-occupation.vue?vue&type=template&id=0b26256e&scoped=true"
import script from "./new-occupation.vue?vue&type=script&lang=js"
export * from "./new-occupation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b26256e",
  null
  
)

export default component.exports